const Tools = {
  designWidth: 5760,
  designHeight: 2160, // 1957
  clientWidth: document.documentElement.getBoundingClientRect().width,

  getFontSize (_px) {
    return _px * (this.clientWidth / this.designWidth);
  },

  // px转vw
  px2vw (_px, unit) {
    let res = _px * 100.0 / this.designWidth;
    if (unit) {
      res = res + unit;
    }
    return res;
  },
  // px转vh
  px2vh (_px, unit) {
    let res = _px * 100.0 / this.designHeight;
    if (unit) {
      res = res + unit;
    }
    return res;
  },

  parseData (data) {
    const originType = data.datav.sourceType;
    switch (originType) {
      case 'RPC': {
        return data.data;
      }
      case 'LOCAL': {
        return JSON.parse(data.data.dataValue);
      }
    }
  }

};

export default Tools;
